import React from 'react'
import { connect } from 'react-redux'
import { compact } from 'lodash'

import { currentUserSelector, loadingCurrentUserSelector } from 'auth'
import { Link } from 'core'
import { Section } from 'layout'
import { openLoginModal } from 'login-modal'
import { SpinnerIcon } from 'icons'
import { ncfddLogoOnDark } from 'images'
import { resourcesMenuSelector, servicesMenuSelector, aboutUsMenuSelector } from 'settings'

import SearchIcon from './icons/search.svg'
import HamburgerIcon from './icons/hamburger.svg'

import { openNavigation } from './actions'
import GlobalNav from './menu/GlobalNav'
import MyAccountMenu from './menu/desktop/my-account-menu/MyAccountMenu'

import css from './style.scss'

export const Header = (props) => {
  const { openNavigation } = props
  const classNames = compact(
    [
      css.header,
      props.transparent ? css.transparent : null
    ]
  ).join(' ')

  if (props.loading) {
    return (
      <header className={classNames}>
        <SpinnerIcon className={css.loadingSpinner} aria-hidden='true' />
        <span className='sr-only' role='status'>Loading</span>
      </header>
    )
  }

  const navigationClassNames = [
    css.navigation,
    !!props.user && css.loggedIn
  ]

  /* eslint-disable react/jsx-handler-names */
  return (
    <header className={classNames}>
      <Section>
        <div className={css.wrapper}>
          <div className={css.logo}>
            <Link to={props.user ? '/dashboard' : '/'}>
              <img
                src={ncfddLogoOnDark}
                alt='NCFDD'
              />
            </Link>
          </div>
          <nav className={compact(navigationClassNames).join(' ')} aria-label='Main navigation'>
            <GlobalNav
              isLoggedIn={props.user}
              services={props.servicesMenu}
              resources={props.resourcesMenu}
              aboutUs={props.aboutUsMenu}
            />
          </nav>
          {!props.navIsOpen && (
            <div className={css.right}>
              {
                props.user
                  ? [
                    <Link key='search_icon' to='/search' aria-label='Search'>
                      <div className={css.icon} aria-hidden='true'>
                        <SearchIcon />
                      </div>
                    </Link>,
                    <MyAccountMenu key='my_account_menu' />
                    ]
                  : [
                    <Link key='join_link' to='/join'>
                      <button
                        className={css.joinButton}
                      >
                        Become a member
                      </button>
                    </Link>,
                    <button
                      key='sign_in_button'
                      type='button'
                      onClick={props.openLoginModal}
                      className={css.signInButton}
                    >
                      Sign In
                    </button>
                    ]
              }
              <button
                type='button'
                className={`${css.icon} ${css.hamburger}`}
                onClick={openNavigation}
                aria-label='Open navigation menu'
                aria-expanded={props.navIsOpen}
              >
                <HamburgerIcon aria-hidden='true' />
              </button>
            </div>
          )}
        </div>
      </Section>
    </header>
  )
}

Header.propTypes = {
  transparent: React.PropTypes.bool,
  user: React.PropTypes.shape({
    name: React.PropTypes.string
  }),
  servicesMenu: React.PropTypes.array,
  aboutUsMenu: React.PropTypes.array,
  resourcesMenu: React.PropTypes.array,
  openLoginModal: React.PropTypes.func.isRequired,
  navIsOpen: React.PropTypes.bool
}

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  loading: loadingCurrentUserSelector(state),
  servicesMenu: servicesMenuSelector(state),
  aboutUsMenu: aboutUsMenuSelector(state),
  resourcesMenu: resourcesMenuSelector(state),
  navIsOpen: state.header.navIsOpen
})

const mapDispatchToProps = { openNavigation, openLoginModal }

export default connect(mapStateToProps, mapDispatchToProps)(Header)
